import { ProductSubtype } from "src/app/ui/models/domains/pbm/Benefit/product-subtype";
import { ProductType } from "src/app/ui/models/domains/pbm/Benefit/product-type";
import { Injectable } from "@angular/core";
import { Network, NetworkComercialProduct } from "src/app/ui/models/domains/pbm/Benefit/network";
import { AbstractParser } from "../../parser";

@Injectable()
export class NetworkParser extends AbstractParser<Network[]> {
  parse(payload: any): Network[] {
    let networkList: Network[] = [];
    if (payload && payload.Data) {
      networkList = payload.Data.map((item) => {
        const network = new Network();
        network.setNetworkInfoKey(item.NetworkInfoKey);
        network.setFiscalNumber(item.FiscalNumber.Value);
        network.setCorporateName(item.CorporateName);
        network.setTradingName(item.TradingName);
        network.setDisplayName(item.DisplayName);
        network.setNetworkComercialProductList(this.parseNetworkComercialProducts(item.NetworkComercialProducts));
        return network;
      });
    }
    return networkList;
  }

  parseUnicNetwork(payload: any): Network {
    const network = new Network();
    if (payload) {
      network.setNetworkInfoKey(payload.NetworkInfoKey);
      network.setFiscalNumber(typeof payload.FiscalNumber === "string" ? payload.FiscalNumber : payload.FiscalNumber.Value);
      network.setCorporateName(payload.CorporateName || payload.Name);
      network.setTradingName(payload.TradingName);
      network.setDisplayName(payload.DisplayName);
      network.setNetworkComercialProductList(this.parseNetworkComercialProducts(payload.NetworkComercialProducts));
      return network;
    }
    return network;
  }

  private parseNetworkComercialProducts(payload: any): NetworkComercialProduct[] {
    let networkComercialProductList = new Array<NetworkComercialProduct>();
    if (payload) {
      networkComercialProductList = payload.map((item) => {
        const networkComercialProduct = new NetworkComercialProduct();
        networkComercialProduct.setDiscount(item.Discount);
        networkComercialProduct.setProductType(this.parseProductType(item.ProductType));
        networkComercialProduct.setProductSubtype(this.parseProductSubType(item.ProductSubType));
        return networkComercialProduct;
      });
    }
    return networkComercialProductList;
  }

  private parseProductType(payload: any): ProductType {
    const productType = new ProductType();
    productType.setKey(payload.Key);
    productType.setValue(payload.Value);
    return productType;
  }

  private parseProductSubType(payload: any): ProductSubtype {
    const productSubType = new ProductSubtype();
    productSubType.setKey(payload.Key);
    productSubType.setValue(payload.Value);
    return productSubType;
  }
}
